import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ConfirmationDialogComponent } from './confirmation-dialog.component';
@Injectable()
export class ConfirmationDialogService {
  constructor(private dialog: MatDialog) { }
  dialogRef: MatDialogRef<ConfirmationDialogComponent>;
  
  public open(options) {
    this.dialogRef = this.dialog.open(ConfirmationDialogComponent, {    
         data: {
            btnCancelText:options.btnCancelText,
            btnConfirmText:options.btnConfirmText,
            message:options.message
         },disableClose: true
    });
  }
  public confirmed(): Observable<any> {
    
    return this.dialogRef.afterClosed().pipe(take(1), map(res => {
        return res;
      }
    ));
  }
}